import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "gfu-hero-banner__slide is-active _bgc--neutral-950" }
const _hoisted_2 = { class: "gfu-hero-banner__content gfu-homepage-wrapper" }
const _hoisted_3 = { class: "gfu-hero-banner__meta" }
const _hoisted_4 = { class: "_mt-2" }
const _hoisted_5 = { class: "_flexcol _gap-1 _mb-1" }
const _hoisted_6 = { class: "gfu-hero-banner__nav" }
const _hoisted_7 = { class: "gfu-hero-banner__nav-viewport" }
const _hoisted_8 = { class: "gfu-hero-banner__nav-track" }
const _hoisted_9 = {
  key: 0,
  class: "gfu-hero-banner__nav-buttons"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_skeleton_line = _resolveComponent("skeleton-line")
  const _component_skeleton_button = _resolveComponent("skeleton-button")
  const _component_skeleton_wrapper = _resolveComponent("skeleton-wrapper")

  return (_openBlock(), _createBlock(_component_skeleton_wrapper, {
    class: "gfu-hero-banner",
    "has-animation": false
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_skeleton_line, {
              height: 12,
              class: "_rounded--common _mb-2",
              "width-percent": 30
            }),
            _createVNode(_component_skeleton_line, { height: 30 }),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_skeleton_line, {
                  height: 24,
                  "width-percent": 40
                }),
                _createVNode(_component_skeleton_line, {
                  height: 24,
                  "width-percent": 60
                })
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("nav", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("ul", _hoisted_8, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(8, (item) => {
              return _createElementVNode("li", {
                key: item,
                class: "gfu-hero-banner__nav-item"
              }, [
                _createVNode(_component_skeleton_button, {
                  class: "gfu-hero-banner__thumb _bd--none",
                  height: 50
                })
              ])
            }), 64 /* STABLE_FRAGMENT */))
          ])
        ]),
        (!$options.isLessThanL)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createVNode(_component_skeleton_button, {
                class: "gfu-btn",
                height: 30
              }),
              _createVNode(_component_skeleton_button, {
                class: "gfu-btn",
                height: 30
              })
            ]))
          : _createCommentVNode("v-if", true)
      ])
    ]),
    _: 1 /* STABLE */
  }))
}